import { useTranslation } from 'react-i18next';
import { formatter } from '../../constants/utilityFunctions';
import CardData from '../dashboard/cardData';
import { Clock } from '../icons';

interface IDurationDisplayProperties {
  title: string;
  durationInHours: number;
  type?: string;
}
export function HoursDurationDisplay({
  title,
  durationInHours,
  type = 'hours',
}: Readonly<IDurationDisplayProperties>) {
  const { t } = useTranslation();
  const formatDuration = (decimalHours: number): string => {
    const totalMinutes = Math.round(decimalHours * 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    const formattedHours = formatter.regionalNumberFormat({ value: decimalHours });
    return `${formattedHours} ${t('common:h')} (${formattedTime})`;
  };
  return (
    <CardData
      type={type}
      icon={<Clock />}
      title={title}
      content={formatDuration(durationInHours)}
    />
  );
}
